import { DiagramSnapshot } from 'src/containers/ProjectDiagram/types/diagram';

export const getPreviousMapping = (diagram: DiagramSnapshot, id: string) => {
  return diagram.model.modelData.draftData?.prevMappingDataMap[id];
};
